import { ThemeOptions } from "@mui/material/styles";

export const mixins: ThemeOptions["mixins"] = {
  toolbar: {
    minHeight: 40,
    paddingLeft: 20,
    paddingRight: 20,
    "@media (min-width:600px)": {
      minHeight: 40,
      paddingLeft: 20,
      paddingRight: 20,
    },
  },
};
